module.exports = __webpack_public_path__ + "static/splash-862dd1aab5362a3449f876959363ec5a.jpg";